<template>
  <div class="text-with-icon-button">
    <p class="text-with-icon-button_text">
      {{ text }}
    </p>
    <div class="text-with-icon-button_btns">
      <IconButton
        v-for="(button,buttonIndex) in buttonList"
        :key="buttonIndex"
        :icon="button.icon"
        :color="button.color"
        @click="$_buttonClick(button)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "TextWithIconButton",
  props: {
    text: {
      type: String,
      default: "",
    },
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_buttonClick(button) {
      this.$emit("btn-click", button.value);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/text-with-icon-button";
</style>